import axios from 'axios'

// 新增点对点评价设置
export function addEvaluateSet (datas) {
  const url = `/evaluateSet/addEvaluateSet`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 获取点对点评价设置列表
export function queryEvaluateSetPage (datas) {
  const url = `/evaluateSet/queryEvaluateSetPage`
  return new Promise((resolve, reject) => {
    axios.get(url, {params: datas}).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 编辑回显点对点评价设置
export function editReturnEvaluateSet (datas) {
  const url = `/evaluateSet/editReturnEvaluateSet`
  return new Promise((resolve, reject) => {
    axios.get(url, {params: datas}).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 编辑提交点对点评价设置
export function editEvaluateSet (datas) {
  const url = `/evaluateSet/editEvaluateSet`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 上下架点对点评价设置
export function deleteEvaluateSet (datas) {
  const url = `/evaluateSet/deleteEvaluateSet`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 获取点对点评价统计列表
export function queryEvaluateStatisticsPage (datas) {
  const url = `/evaluateSet/queryEvaluateStatisticsPage`
  return new Promise((resolve, reject) => {
    axios.get(url, {params: datas}).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 获取点对点评价详情
export function queryEvaluateDetail (datas) {
  const url = `/evaluateSet/queryEvaluateDetail`
  return new Promise((resolve, reject) => {
    axios.get(url, {params: datas}).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 导出点对点评价统计列表
export function exportEvaluateStatistics (datas) {
  const url = `/evaluateSet/exportEvaluateStatistics`
  return new Promise((resolve, reject) => {
    axios.get(url, {params: datas}).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/appraiseManage/index.js